exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tabs-wrapper[data-v-52eeb7b3] {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 0 3px 0 25px;\n}\n.tabs-wrapper .tabs-header[data-v-52eeb7b3] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.tabs-wrapper .tabs-header .tab[data-v-52eeb7b3] {\n  cursor: pointer;\n  margin: 10px 15px 10px 0px;\n  border-bottom: 1px solid transparent;\n  padding-bottom: 5px;\n}\n.tabs-wrapper .tabs-header .selected-tab[data-v-52eeb7b3] {\n  border-bottom: 1px solid orange;\n  font-weight: bold;\n}\n", ""]);

// exports
